import _ from 'lodash';
import { lsApiService, lsErrorService } from 'ls-vue-common';
import {
  TERMS_OF_SERVICE__MUTATE_LOADING_STATUS,
  TERMS_OF_SERVICE__MUTATE_HAS_AGREED,
  TERMS_OF_SERVICE__ACCEPT,
} from '@/store/types';

export const CURRENT_CUST_TOS_VERSION = 'cust-v2023-11';
const createInitialState = () => {
  return {
    loadingStatus: {
      isUpdating: false,
    },
    hasAgreedToTOS: true,
  };
};

export const mutations = {
  [TERMS_OF_SERVICE__MUTATE_LOADING_STATUS](state, payload) {
    _.assign(state.loadingStatus, payload);
  },
  [TERMS_OF_SERVICE__MUTATE_HAS_AGREED](state, payload) {
    state.hasAgreedToTOS = payload;
  },
};
export const actions = {
  [TERMS_OF_SERVICE__ACCEPT]({ rootState, commit }, { onSuccess }) {
    const { customer_id: customerId } = rootState.auth.user;

    commit(TERMS_OF_SERVICE__MUTATE_LOADING_STATUS, {
      isUpdating: true,
    });

    return lsApiService
      .request({
        method: 'POST',
        route: `/customers/${customerId}/terms-of-service/accept`,
        payload: {
          tos_version: CURRENT_CUST_TOS_VERSION,
        },
      })
      .then(() => {
        commit(TERMS_OF_SERVICE__MUTATE_HAS_AGREED, true);
        onSuccess();
      })
      .catch((error) => {
        if (
          _.get(error, 'message') === 'The current terms of service have already been accepted.'
        ) {
          commit(TERMS_OF_SERVICE__MUTATE_HAS_AGREED, true);
          onSuccess();
        }

        lsErrorService.log({
          error,
          showAlert: true,
        });
      })
      .finally(() => {
        commit(TERMS_OF_SERVICE__MUTATE_LOADING_STATUS, {
          isUpdating: false,
        });
      });
  },
};

export const termsOfService = {
  state: createInitialState,
  mutations,
  actions,
};
